import SearchProgramResults from './SearchProgramResults';

export default SearchProgramResults;
